import Categories from "../Categories/Categories"
import SearchBar from "../SearchBar/SearchBar"


const SearchOptions = (props) => {

    return (
        <div className="fl-cl searchOptions__container">
            <SearchBar onClick={props.onClick} placeholder={props.placeholder} />
            <Categories onClick={props.onClick} />
        </div>
    )
}

export default SearchOptions